import {IncomingHttpHeaders} from "http"

const getRealmFromHeaders = (headers: IncomingHttpHeaders) => `${headers["x-next-realm"] as string}`

export default getRealmFromHeaders
